<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">Indicator
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content">
  <h2>Customized Indicator</h2>
  <div class="content__tools-wrap" *ngIf="isBrowser">
    <div class="content__row">
    <label for="color" class="content__row-label">color</label>
    <select (change)="onChange($event)" placeholder="Type" class="c-input-group__control" id="color">
      <ng-container>
        <option [value]="color.colorCode" *ngFor="let color of colorList">{{color.name}}</option>
      </ng-container>
    </select></div>
    <div class="content__row">
    <div class="c-input-check-inline">
      <input id="hasValue" class="c-input-check-inline__input" type="checkbox" name="hasValue" [(ngModel)]="hasValue">
      <label for="hasValue" class="c-input-check-inline__label">Has Value</label> 
      <label for="type" class="content__row-label">type</label> 
      <select [(ngModel)]="valueType" id="button" placeholder="valueType" name="valueType" class="c-input-group__control c-input-group__control--left-margin" aria-label="select">
        <ng-container *ngFor="let valueType of valueTypeList">
          <option [value]="valueType">{{ valueType }}</option>
        </ng-container>
      </select>
      <input *ngIf="valueType === 'number'" id="value" class="c-input-group__control c-input-group__control--without-padding" placeholder="5" type="number" [(ngModel)]="value" min="1" max="100000">
      <label for="value" class="u-display-none">Value</label>
      <input *ngIf="valueType === 'string'" id="value1" class="c-input-group__control" placeholder="Enter Text" type="text" [(ngModel)]="value">
      <label for="value1" class="u-display-none">value</label>
      <input id="statusUrl" class="c-input-group__control" placeholder="Url" type="text" [(ngModel)]="statusUrl">
      <label for="statusUrl" class="u-display-none">Status Url</label>
    </div></div>
  </div>
  <div>
    <maced-indicator [color]="colorObject.colorCode" [value]="value" [statusUrl]="statusUrl" [queryParams]="queryParams"
      [borderColor]="colorObject.borderColor" [statusAriaLabel]="colorObject.label" [hasValue]="hasValue"
      [status]="colorObject.status" indicatorId="indicatorId">
    </maced-indicator>
  </div>
</div>